import { _ as __decorate, a as __metadata, B as BaseComponent } from '../index-BJd2QXLB.js';
import { css, html } from 'lit';
import { queryAssignedElements, property, customElement } from 'lit/decorators.js';
import 'lit/directive.js';

var styles = css`.toolbar {
  --bsi-toolbar-bg: var(--bsi-color-background-inverse);
  --bsi-toolbar-divider-color: var(--bsi-color-border-subtle);
  --bsi-toolbar-link-color: var(--bsi-color-text-secondary);
  --bsi-toolbar-icon-color: var(--bsi-icon-secondary);
  --bsi-toolbar-dropdown-padding-x: var(--bsi-spacing-xxs);
  --bsi-toolbar-dropdown-caret-color: var(--bsi-icon-secondary);
  --bsi-toolbar-dropdown-caret-size: var(--bsi-spacing-3xs);
  --bsi-toolbar-dropdown-shadow: var(--bsi-elevation-low);
  --bsi-toolbar-icon-font-size: var(--bsi-icon-size-l);
  --bsi-toolbar-item-gap: var(--bsi-spacing-xs);
  --bsi-toolbar-more-icon-font-size: var(--bsi-label-font-size-xs);
  --bsi-toolbar-badge-border-color: var(--bsi-color-background-inverse);
  --bsi-toolbar-badge-background-color: var(--bsi-color-background-primary);
  --bsi-toolbar-badge-border-radius: var(--bsi-radius-circle);
  --bsi-toolbar-badge-text-color: var(--bsi-color-text-inverse);
  --bsi-toolbar-badge-padding-x: var(--bsi-spacing-3xs);
  --bsi-toolbar-badge-font-size: var(--bsi-label-font-size-xs);
  --bsi-toolbar-label-margin-top: var(--bsi-spacing-3xs);
  --bsi-toolbar-label-font-size: var(--bsi-label-font-size-xs);
  --bsi-toolbar-padding-x: var(--bsi-spacing-xs);
  --bsi-toolbar-padding-y: var(--bsi-spacing-xs);
  --bsi-toolbar-shadow: var(--bsi-elevation-medium);
}

/* stylelint-disable-next-line no-duplicate-selectors */
.toolbar {
  position: relative;
  width: 100%;
  padding: var(--bsi-toolbar-padding-y) var(--bsi-toolbar-padding-x);
  background-color: var(--bsi-toolbar-bg);
  box-shadow: var(--bsi-toolbar-shadow);
}
.toolbar a {
  text-decoration: none;
}
.toolbar .badge-wrapper {
  position: relative;
}
.toolbar .toolbar-badge {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  min-width: 18px;
  height: 18px;
  padding: 0 var(--bsi-toolbar-badge-padding-x);
  border: 1px solid var(--bsi-toolbar-badge-border-color);
  border-radius: var(--bsi-toolbar-badge-border-radius);
  background-color: var(--bsi-toolbar-badge-background-color);
  color: var(--bsi-toolbar-badge-text-color);
  font-size: var(--bsi-toolbar-badge-font-size);
  font-style: normal;
  line-height: 1rem;
}
.toolbar .toolbar-label {
  display: block;
  margin-top: var(--bsi-toolbar-label-margin-top);
  font-size: var(--bsi-toolbar-label-font-size);
  font-weight: 600;
  line-height: 1;
}
.toolbar .toolbar-divider {
  align-self: stretch;
  width: 1px;
  min-width: 1px;
  max-width: 1px;
  height: auto;
  background: var(--bsi-toolbar-divider-color);
  margin-block: var(--bsi-toolbar-padding-y);
}
.toolbar > ul {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin: 0;
  padding: 0;
  gap: var(--bsi-toolbar-item-gap);
}
.toolbar > ul > li {
  height: 100%;
  list-style-type: none;
  text-align: center;
}
.toolbar a,
.toolbar .btn-dropdown {
  display: block;
  color: var(--bsi-toolbar-link-color);
}
.toolbar a .icon,
.toolbar .btn-dropdown .icon {
  fill: var(--bsi-toolbar-icon-color);
}
.toolbar a.active,
.toolbar .btn-dropdown.active {
  --bsi-toolbar-link-color: var(--bsi-color-text-primary);
  --bsi-toolbar-icon-color: var(--bsi-icon-primary);
}
.toolbar a.disabled,
.toolbar .btn-dropdown.disabled {
  --bsi-toolbar-link-color: var(--bsi-color-text-disabled);
  --bsi-toolbar-icon-color: var(--bsi-icon-disabled);
  cursor: not-allowed;
}
.toolbar a.disabled:hover,
.toolbar .btn-dropdown.disabled:hover {
  text-decoration: none;
}
.toolbar a.disabled:after,
.toolbar .btn-dropdown.disabled:after {
  color: var(--bsi-toolbar-link-color);
}
.toolbar a:not(.disabled):hover,
.toolbar .btn-dropdown:not(.disabled):hover {
  --bsi-toolbar-link-color: var(--bsi-color-link-hover);
  --bsi-toolbar-icon-color: var(--bsi-icon-primary-hover);
  text-decoration: underline;
}
.toolbar a,
.toolbar .btn-dropdown {
  /* stylelint-disable */
}
.toolbar a _:-ms-fullscreen, .toolbar a:not(.disabled):hover,
.toolbar .btn-dropdown _:-ms-fullscreen,
.toolbar .btn-dropdown:not(.disabled):hover {
  text-decoration: none;
}
.toolbar a,
.toolbar .btn-dropdown {
  /* stylelint-enable */
}
.toolbar.toolbar-medium {
  --bsi-toolbar-icon-font-size: var(--bsi-icon-size-m);
}
.toolbar.toolbar-medium .toolbar-badge {
  width: 10px;
  min-width: 10px;
  height: 10px;
  padding: 0;
}
.toolbar.toolbar-small {
  --bsi-toolbar-icon-font-size: var(--bsi-icon-size-s);
  --bsi-toolbar-padding-y: var(--bsi-spacing-xxs);
}
.toolbar.toolbar-small .toolbar-badge {
  width: 8px;
  min-width: 8px;
  height: 8px;
  padding: 0;
}
.toolbar.toolbar-vertical {
  position: absolute;
  top: 0;
  bottom: 0;
  width: auto;
  height: 100%;
}
.toolbar.toolbar-vertical > ul {
  flex-direction: column;
  height: 100%;
}
.toolbar.toolbar-vertical > ul > li {
  display: flex;
  align-items: center;
  margin: var(--bsi-toolbar-item-margin-y) var(--bsi-toolbar-item-margin-x);
}
.toolbar.toolbar-vertical > ul > li.toolbar-divider {
  align-self: auto;
  width: calc(100% - (var(--bsi-toolbar-padding-x)));
  min-width: 0;
  max-width: none;
  height: 1px;
  min-height: 1px;
  max-height: 1px;
  margin: 0;
}
.toolbar.toolbar-vertical.toolbar-medium .dropdown-menu {
  top: calc(-100% - 25px) !important;
}
.toolbar.toolbar-vertical.toolbar-small .dropdown-menu {
  top: calc(-100% - 35px) !important;
}
.toolbar.toolbar-vertical .btn-dropdown {
  padding: 0;
}
.toolbar.toolbar-vertical .btn-dropdown[aria-expanded=true]:after {
  transform: rotate(90deg) scaleX(-1);
}
.toolbar.toolbar-vertical .dropdown-menu {
  --bsi-dropdown-box-shadow: var(--bsi-toolbar-dropdown-shadow);
  top: calc(-100% - 28px) !important;
  left: calc(100% + 24px) !important;
  margin: 0;
}
.toolbar.toolbar-vertical .dropdown-menu:before {
  top: 24px;
  left: -6px;
}
.toolbar.toolbar-vertical .badge-wrapper {
  width: 100%;
}
.toolbar .btn-dropdown {
  position: relative;
  width: 100%;
  padding: 0;
}
.toolbar .btn-dropdown.toolbar-more:after {
  display: none;
}
.toolbar .btn-dropdown:not(.disabled).active {
  box-shadow: none;
}
.toolbar .btn-dropdown:not(.disabled).active:focus {
  box-shadow: 0 0 0 0.25rem rgba(0, 102, 204, 0.25);
}
.toolbar .btn-dropdown:focus {
  box-shadow: 0 0 0 0.25rem rgba(0, 102, 204, 0.25);
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

:host {
  display: block;
}

.toolbar {
  --bsi-toolbar-badge-size: 18px;
  --bsi-toolbar-badge-top: -4px;
  box-sizing: border-box;
}
.toolbar.toolbar-small {
  --bsi-toolbar-badge-size: 8px;
  --bsi-toolbar-badge-top: 2px;
}
.toolbar.toolbar-medium {
  --bsi-toolbar-badge-size: 10px;
  --bsi-toolbar-badge-top: -2px;
}
.toolbar.toolbar-vertical > ul {
  min-height: fit-content;
}`;

/**
 * Toolbar component following repository conventions.
 * - Renders a navigation menu with icon-based items
 * - Supports multiple sizes: lg (large/default), md (medium), sm (small)
 * - Supports orientations: horizontal (default), vertical
 * - Can contain links, buttons, dropdowns, and dividers
 *
 * @element it-toolbar
 */
let ItToolbar = class ItToolbar extends BaseComponent {
    constructor() {
        super(...arguments);
        /**
         * Size variant of the toolbar.
         * - lg: Large (default) - shows labels and icons
         * - md: Medium - hides labels, uses visually-hidden spans for a11y
         * - sm: Small - hides labels, uses visually-hidden spans for a11y
         */
        this.size = 'lg';
        /**
         * Orientation of the toolbar.
         * - horizontal: (default) items arranged horizontally
         * - vertical: items arranged vertically
         */
        this.orientation = 'horizontal';
        /**
         * Aria label for the toolbar navigation.
         */
        this.itAriaLabel = 'Toolbar';
        this._onSlotChange = () => {
            // Quando cambiano i children, aggiorna tutte le proprietà
            this.updateChildrenProperties();
        };
    }
    updated(changedProperties) {
        // Propaga le proprietà ai figli quando cambiano
        if (changedProperties.has('size') || changedProperties.has('orientation')) {
            this.updateChildrenProperties();
        }
    }
    firstUpdated(changedProperties) {
        super.firstUpdated?.(changedProperties);
        // Inizializza le proprietà sui figli
        this.updateChildrenProperties();
    }
    updateChildrenProperties() {
        this.toolbarItems.forEach((item) => {
            if (this.size === 'md' || this.size === 'sm') {
                item.setAttribute('hide-label', '');
                item.setAttribute('hide-badge', '');
            }
            else {
                item.removeAttribute('hide-label');
                item.removeAttribute('hide-badge');
            }
            if (item.divider) {
                item.setAttribute('role', 'separator');
                if (this.orientation === 'vertical') {
                    item.setAttribute('aria-orientation', 'horizontal');
                }
                else {
                    item.setAttribute('aria-orientation', 'vertical');
                }
            }
            else {
                item.setAttribute('role', 'presentation');
                item.removeAttribute('aria-orientation');
            }
        });
    }
    render() {
        const navClasses = this.composeClass('toolbar', {
            'toolbar-medium': this.size === 'md',
            'toolbar-small': this.size === 'sm',
            'toolbar-vertical': this.orientation === 'vertical',
        }, this.className);
        return html `
      <nav aria-label="${this.itAriaLabel}" part="toolbar-container" class="${navClasses}">
        <ul part="toolbar-list" role="toolbar" aria-orientation="${this.orientation}">
          <slot @slotchange="${this._onSlotChange}"></slot>
        </ul>
      </nav>
    `;
    }
};
ItToolbar.styles = styles;
__decorate([
    queryAssignedElements({ selector: 'it-toolbar-item' }),
    __metadata("design:type", Array)
], ItToolbar.prototype, "toolbarItems", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItToolbar.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItToolbar.prototype, "orientation", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'it-aria-label' }),
    __metadata("design:type", Object)
], ItToolbar.prototype, "itAriaLabel", void 0);
ItToolbar = __decorate([
    customElement('it-toolbar')
], ItToolbar);

export { ItToolbar };
//# sourceMappingURL=it-toolbar.js.map
